<div class="mar">
<mat-card *ngIf="show">
  <mat-card-header>
  <mat-card-title>
    <h1 class="head">Feedbacks Given By Users</h1>
  </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="table-responsive">
    <table class="table">
      <tr>
        <th>Name</th>
        <th>email</th>
        <th>Rating</th>
        <th>Comment</th>
      </tr>
      <tr *ngFor="let i of feed">
        <td>{{i.name}}</td>
        <td>{{i.email}}</td>
        <td>{{i.satisfaction}}</td>
        <td>{{i.comment}}</td>
      </tr>

    </table>
    </div>
  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-header>
  <mat-card-title>
    <div class="row">
      <div class="col-sm-6">
        <h1 class="head">Users</h1>
      </div>
      <div class="col-sm-6">
        <button type="button" (click)="toggle()" mat-button>{{buttonName}}</button>
      </div>
    </div>
  </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="table-responsive">
    <table class="table">
      <tr>
        <th>Name</th>
        <th>email</th>
        <th>Gender</th>
        <th>Username</th>
        <th>Password</th>
        <th>Action</th>
      </tr>
      <tr *ngFor="let i of user">
        <td>{{i.name}}</td>
        <td>{{i.email}}</td>
        <td>{{i.gender}}</td>
        <td>{{i.username}}</td>
        <td>{{i.password}}</td>
        <td><button mat-raised-button (click)="delete(i.username)">Delete</button></td>
      </tr>
    </table>
    </div>
  </mat-card-content>
</mat-card>
</div>
